import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { db } from '../../lib/supabase'

export default function SiteApi() {
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: siteConfig } = await db.getSiteConfig()
        
        const response = {
          "@context": "https://schema.org",
          "@type": "ShoppingCenter",
          name: siteConfig?.org_name || "Plaza Aurora",
          description: "Centro comercial outlet en Lima Norte con las mejores marcas y precios. Ubicado en Independencia, atendemos a Los Olivos, San Martín de Porres, Comas y toda Lima Norte.",
          url: siteConfig?.site_url || "https://www.plazaaurora.pe",
          logo: siteConfig?.logo_url || "https://ffbzkwlpbswgbngwvyvp.supabase.co/storage/v1/object/public/assets/logo/PlazaAurora_Logo.png",
          email: siteConfig?.contact_email || "comercial@plazaaurora.pe",
          telephone: siteConfig?.contact_phone || null,
          address: {
            "@type": "PostalAddress",
            streetAddress: siteConfig?.address_street || "Av. Carlos Izaguirre 271-275",
            addressLocality: siteConfig?.address_locality || "Independencia",
            addressRegion: siteConfig?.address_region || "Lima",
            postalCode: siteConfig?.postal_code || "15113",
            addressCountry: siteConfig?.address_country || "PE"
          },
          geo: {
            "@type": "GeoCoordinates",
            latitude: siteConfig?.latitude || -11.990286,
            longitude: siteConfig?.longitude || -77.062296
          },
          openingHours: "Mo-Su 08:00-22:00",
          openingHoursSpecification: siteConfig?.opening_hours_json || [
            {"@type":"OpeningHoursSpecification","dayOfWeek":"Monday","opens":"08:00","closes":"22:00"},
            {"@type":"OpeningHoursSpecification","dayOfWeek":"Tuesday","opens":"08:00","closes":"22:00"},
            {"@type":"OpeningHoursSpecification","dayOfWeek":"Wednesday","opens":"08:00","closes":"22:00"},
            {"@type":"OpeningHoursSpecification","dayOfWeek":"Thursday","opens":"08:00","closes":"22:00"},
            {"@type":"OpeningHoursSpecification","dayOfWeek":"Friday","opens":"08:00","closes":"22:00"},
            {"@type":"OpeningHoursSpecification","dayOfWeek":"Saturday","opens":"08:00","closes":"22:00"},
            {"@type":"OpeningHoursSpecification","dayOfWeek":"Sunday","opens":"08:00","closes":"22:00"}
          ],
          sameAs: siteConfig?.same_as || [
            "https://www.facebook.com/profile.php?id=61582145587744",
            "https://www.instagram.com/ccplazaaurora/",
            "https://www.tiktok.com/@ccplazaaurora"
          ],
          priceRange: "$$",
          currenciesAccepted: "PEN",
          paymentAccepted: "Cash, Credit Card, Debit Card",
          areaServed: [
            {
              "@type": "City",
              name: "Independencia",
              containedInPlace: {"@type": "City", "name": "Lima"}
            },
            {
              "@type": "City",
              name: "Los Olivos",
              containedInPlace: {"@type": "City", "name": "Lima"}
            },
            {
              "@type": "City",
              name: "San Martín de Porres",
              containedInPlace: {"@type": "City", "name": "Lima"}
            },
            {
              "@type": "City",
              name: "Comas",
              containedInPlace: {"@type": "City", "name": "Lima"}
            },
            {
              "@type": "Place",
              name: "Lima Norte"
            }
          ],
          keywords: "outlet Lima Norte, tiendas Independencia, mejores ofertas Lima Norte, promociones Los Olivos, tiendas San Martín de Porres, descuentos Comas, centro comercial Independencia, outlet Peru, mejores precios Lima, marcas reconocidas Lima Norte",
          hasMap: siteConfig?.google_maps_url || "https://www.google.com/maps/dir//Av.+Carlos+Izaguirre+271-275+Independencia+15113/@-11.990286,-77.062296,14z"
        }

        // Return as JSON
        const blob = new Blob([JSON.stringify(response, null, 2)], { type: 'application/json' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'site.json'
        link.click()
        URL.revokeObjectURL(url)
        
        // Redirect after download
        setTimeout(() => navigate('/'), 1000)
      } catch (error) {
        console.error('Error generating site.json:', error)
        navigate('/')
      }
    }

    fetchData()
  }, [navigate])

  return (
    <div style={{ 
      maxWidth: '600px', 
      margin: '4rem auto', 
      padding: '2rem',
      textAlign: 'center'
    }}>
      <h1 style={{ fontFamily: 'var(--font-display)', marginBottom: '1rem' }}>
        Generando site.json...
      </h1>
      <p style={{ color: 'var(--color-text-muted)' }}>
        Tu descarga comenzará en un momento.
      </p>
    </div>
  )
}
